/**
 * GA4 helpers — no-op when gtag is not loaded.
 */

const AI_REFERRER_HOSTS = [
  'chatgpt.com',
  'chat.openai.com',
  'perplexity.ai',
  'gemini.google.com',
  'copilot.microsoft.com',
  'claude.ai',
  'bing.com',
];

export function classifyReferrer(referrer = '') {
  if (!referrer) return { type: 'direct', source: 'direct' };
  try {
    const host = new URL(referrer).hostname.replace(/^www\./, '').toLowerCase();
    const isAi = AI_REFERRER_HOSTS.some(
      (h) => host === h || host.endsWith(`.${h}`)
    );
    return { type: isAi ? 'ai' : 'referral', source: host };
  } catch {
    return { type: 'unknown', source: 'unknown' };
  }
}

function gtagSafe(...args) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag(...args);
  }
}

export function trackEvent(eventName, params = {}) {
  gtagSafe('event', eventName, params);
}

export function trackPageView({ path, title } = {}) {
  const referrer = typeof document !== 'undefined' ? document.referrer : '';
  const { type, source } = classifyReferrer(referrer);

  trackEvent('page_view', {
    page_path: path,
    page_title: title,
    page_referrer: referrer || '(direct)',
    traffic_type: type,
    traffic_source: source,
  });
}

export function trackSearch({ query, resultCount } = {}) {
  trackEvent('search', {
    search_term: query,
    result_count: resultCount,
  });
}
